import React from "react";
import "./AreaDetail.scss";

function StateDetail({
  selectedStateIntro,
  setSelectedStateIntro,
  setShowStateDetail,
  handleClickNavButtons,
  currentStateName,
}) {
  const stateDetailContent = {
    disclaimer:
      "This State of Housing in America map covers 173 metro areas across America, representing roughly 72% of the U.S. population.",
    Wyoming:
      "As the least populous and second-least densely populated state in the United States, with a large percentage of its area consisting of national parks, federal land, and reservations, Wyoming’s metro areas are not large enough to be covered by this map.",
    Montana:
      "Montana is the seventh-least populous state and the third-least densely populated state, with a significant percentage of its land covered by national parks, mountain ranges, and federally-protected areas. As such, none of its metro areas meet the criteria for this map.",
    Alaska:
      "Alaska is is the third-least populous and the least densely populated state, with much of its area covered by national parks, wilderness areas, and reservations. As such, Alaska’s metro areas are not covered by this map.",
  };

  return (
    <section className="areaDetail areaDetail--state">
      <div className="areaDetail__head areaDetail__head--state">
        {currentStateName === null ? (
          <div
            className="areaDetail__x"
            onClick={() => {
              setShowStateDetail(false);
              setSelectedStateIntro(null);
            }}
          >
            X
          </div>
        ) : (
          <></>
        )}

        <div className="areaDetail__head__title">
          <p className="areaDetail__head__title__state areaDetail__head__title__state--state ">
            {selectedStateIntro ? selectedStateIntro : currentStateName}
          </p>
        </div>
      </div>
      <div className="areaDetail__content areaDetail__content--state">
        <p className="areaDetail__content__detail__main areaDetail__content__detail__main--state">
          {stateDetailContent.disclaimer}
        </p>
        <p className="areaDetail__content__detail__main areaDetail__content__detail__main--state areaDetail__content__detail__main--state--copy">
          {selectedStateIntro
            ? stateDetailContent[selectedStateIntro]
            : stateDetailContent[currentStateName]}
        </p>
        {currentStateName === null ? (
          <p
            className="areaDetail__content__detail__main areaDetail__content__detail__main--state returnToIntro"
            onClick={() => {
              handleClickNavButtons("intro");
            }}
          >
            Click to return to state view -->
          </p>
        ) : (
          <></>
        )}
      </div>
    </section>
  );
}

export default StateDetail;
